import CashFlowTablesEnum from '@/views/cashFlowGroupers/mainGrouper/enums/CashFlowTablesEnum';
import IPredictedFlowGrouperList from '../../interfaces/groupers/IPredictedFlowGrouperList';
import ITotalsData from '../../interfaces/groupers/ITotalsData';

export const setDisregardValueButtonShow = (
  identifier: string,
  totalIndex: number,
  mustAppear: boolean,
): void => {
  const elementByData = document.querySelector(`.disregard-value-button[data-id='${identifier}'][data-total-index='${totalIndex}']`);

  if (!elementByData) {
    return;
  }

  if (mustAppear) {
    elementByData.classList.add('disregard-button-pointer-appear');
  } else {
    elementByData.classList.remove('disregard-button-pointer-appear');
  }
};

export const setApproveButtonShow = (
  identifier: string,
  totalIndex: number,
  isReleased: boolean,
): void => {
  const elementByData = document.querySelector(`.approve-button[data-id='${identifier}'][data-total-index='${totalIndex}']`);

  if (!elementByData) {
    return;
  }

  if (isReleased) {
    elementByData.classList.remove('approve-disapprove-button-pointer-appear');
  } else {
    elementByData.classList.add('approve-disapprove-button-pointer-appear');
  }
};

export const setClassStatesToLinesAndTotals = (
  destructuredBankBalance: IPredictedFlowGrouperList[],
) => {
  for (let baseIndex = 0; baseIndex < destructuredBankBalance.length; baseIndex += 1) {
    const { show, totals, identifier } = destructuredBankBalance[baseIndex];

    const element = document.getElementById(`item_${baseIndex}`);

    if (element) {
      element.style.display = !show ? 'none' : '';
    }

    for (let totalIndex = 0; totalIndex < totals.length; totalIndex += 1) {
      setApproveButtonShow(
        identifier,
        totalIndex,
        totals[totalIndex].isReleased ?? false,
      );
      setDisregardValueButtonShow(
        identifier,
        totalIndex,
        totals[totalIndex].disregardValue,
      );
    }
  }
};

export const mustShowDisregardButtonToActualLine = (
  mustSumAllValues: boolean,
  item: IPredictedFlowGrouperList,
  totalsData: ITotalsData,
) => {
  if (!mustSumAllValues) {
    return false;
  }

  if (
    totalsData.value === 0
    && (
      item.level === 4
      || (item.level === 3 && item.grouperType === CashFlowTablesEnum.BANKS)
    )
  ) {
    return false;
  }

  return true;
};
